import { apiRequest } from "../util/apiUtils";

export const getSiteSettingList = async (params) => {
  try {
    const res = await apiRequest("get", `/site-settings/detail`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const siteSettingAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `site-settings/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};
